<template>

    <!-- PRELOADER
    ============================================= 		
    <div id="loader-wrapper">
        <div id="loader">
            <ul class="cssload-flex-container">
                <li><span class="cssload-loading"></span></li>
            </ul>
        </div>
    </div>-->


    <!-- PAGE CONTENT
    ============================================= -->	
    <div id="page" class="page">


       <header_menu></header_menu>

        <!-- PRESENTATION-->	
        <section id="hero-1" class="bg-fixed hero-section division">
            <div class="container">	
                <div class="row">


                    <!-- HERO TEXT -->
                    <div class="col-md-7 col-lg-6">
                        <div class="hero-txt white-color">	


                            <!-- Title -->
                            <h2 class="h2-lg " data-animation="fadeInUp" data-animation-delay="300">
                                La nouvelle expérience bancaire, sans changer de banque
                            </h2>

                            <!-- Text -->
                            <p class="p-lg " data-animation="fadeInUp" data-animation-delay="400">
                                Tout est fait pour aller à l’essentiel :<br><strong>payer, recharger, consulter votre solde</strong><br>quelle que soit votre carte Visa.
                            </p>

                            <!-- HERO STORE BADGES -->													
                            <div class="hero-stores-badge " data-animation="fadeInUp" data-animation-delay="500">

                                <!-- AppStore -->	
                                <a href="https://play.google.com/store/apps/details?id=weblogy.com.carteabidjan" target="_blank" class="store">
                                    <img class="appstore-white" src="../../public/assets/images/play_store_badge.webp" width="155" height="50" alt="appstore-logo">
                                </a>

                                <!-- AppStore -->	
                                <a href="https://apps.apple.com/app/id1211381693" class="store">
                                    <img class="appstore-white" src="../../public/assets/images/app-store-bage.webp" target="_blank" width="155" height="50" alt="appstore-logo">
                                </a>

                                <!-- AppStore -->	
                                <a href="https://appgallery.huawei.com/app/C104470711" class="store">
                                    <img class="appstore-white" src="../../public/assets/images/app-gallery-badge.webp" target="_blank" width="155" height="50" alt="appstore-logo">
                                </a>

                               
                                                    
                            </div>	<!-- End Store Badges -->
                                
                        </div>	 <!-- End row -->   
                    </div>	 <!-- End container --> 

                    <!-- HERO IMAGE -->
                    <div class="col-md-5 col-lg-5 offset-lg-1 " data-animation="fadeInRight" data-animation-delay="400">	
                        <div class="hero-img">				
                            <img class="img-fluid first_im" src="@/assets/images/Mobile-app-phone.webp" alt="hero-image">
                        </div>
                    </div>


                </div>	   <!-- End row --> 
            </div>      <!-- End container --> 
        </section>	
        <!-- END PRESENTATION -->    

        <!-- MULTI CHOICES SERVICES-->
        <section id="features-1" class="p-bottom-60 featuress-section division">
            <div class="container">
                <div class="row">



                    <!-- FEATURE BOX #1 -->
                    <div class="col-md-6 col-lg-4 bounce " data-animation="fadeInUp" data-animation-delay="300">
                        <a href="https://cabine.apaym.com/rechargement-visa" target="_blank"><div class="fbox-3 box-icon-lg blue-hover">                            
                            
                            <!-- Icon -->
                            <img src="@/assets/images/apaym-recharge-card.webp" class="img-choice">
                                
                            <!-- Title -->
                            <h5 class="h5-md">Recharger vos<br> cartes Visa</h5>
																												
                        </div></a>						
                    </div>	


                    <!-- FEATURE BOX #2 -->
                    <div class="col-md-6 col-lg-4 bounce " data-animation="fadeInUp" data-animation-delay="400">
                        <a href="https://cabine.apaym.com/achat-cartes" target="_blank"><div class="fbox-3 box-icon-lg orange-hover">
                           
                            
                            <!-- Icon -->
                            <img src="@/assets/images/apaym-achat-acrd.webp" class="img-choice">
                                
                            <!-- Title -->
                            <h5 class="h5-md">Acheter des<br>cartes Visa</h5>	                    

                        </div></a>							
                    </div>
                        
                        <!-- FEATURE BOX #6 -->
                    <div class="col-md-6 col-lg-4 bounce " data-animation="fadeInUp" data-animation-delay="800">
                       <a href="https://pay.apaym.com/" target="_blank"> <div class="fbox-3 box-icon-lg purple-hover">
                            
                            
                            <!-- Icon -->
                            <img src="@/assets/images/apaym-payer-marchand.webp" class="img-choice">
                                
                            <!-- Title -->
                            <h5 class="h5-md">Payer un marchand<br> APAYM Pro</h5>
																											
                        </div></a>							
                    </div>	 
                    
                    <!-- FEATURE BOX #3 -->
                    <div class="col-md-6 col-lg-4 bounce " data-animation="fadeInUp" data-animation-delay="500">
                        <a href="https://pay.apaym.com/abidjannettaxi" target="_blank"><div class="fbox-3 box-icon-lg red-hover">
                           
                            
                            <!-- Icon -->
                            <img src="@/assets/images/apaym-yango.webp" class="img-choice">
                                
                            <!-- Title -->
                            <h5 class="h5-md">Recharger des<br> comptes Yango</h5>
                                          
                        </div></a>							
                    </div>
                            
                            
                    <!-- FEATURE BOX #4 -->
                    <div class="col-md-6 col-lg-4 bounce " data-animation="fadeInUp" data-animation-delay="600">
                        <div class="fbox-3 box-icon-lg rose-hover" @click="showWarning">
                          
                            
                            <!-- Icon -->
                            <img src="@/assets/images/apaym-credit-tel.webp" class="img-choice" >
                                
                            <!-- Title -->
                            <h5 class="h5-md">Acheter du crédit<br> téléphonique</h5>	

                        </div>							
                    </div>	


                    <!-- FEATURE BOX #5 -->
                    <div class="col-md-6 col-lg-4 bounce " data-animation="fadeInUp" data-animation-delay="700">
                        <div class="fbox-3 box-icon-lg green-hover" @click="showWarning">
                           
                            
                            <!-- Icon -->
                            <img src="@/assets/images/apaym-payer-factures.webp" class="img-choice" >
                                
                            <!-- Title -->
                            <h5 class="h5-md">Paiement de <br>vos factures</h5>

                        </div>							
                    </div>

                </div>	   <!-- End row -->		

                
            </div>	   <!-- End container -->		
        </section>	
        <!-- END MULTI CHOICES SERVICES --> 

        <!-- NOS CARTES VISA-->
		<section id="cartes" class="p-bottom-80 content-section carte_part">
            <div class="bg-scroll p-top-100 bg-inner bg-lightpurple division">	
                <div class="container white-color">
                    <div class="row d-flex align-items-center">

                                
                        <!-- CONTENT TXT -->	
                        <div class="col-md-6">
                            <div class="content-txt ind-45">

                                
                                <!-- Title -->
                                <h2 class="h2-xs " >
                                    La carte qui vous ressemble
                                </h2>

                                <p><br>
                                 <img class="img-fluid im_cart_ev im_apear" src="@/assets/images/img-crte-ev.png" alt="content-image">
                                </p>
                                <!-- Text -->
                                <p>
                                    La carte qui vous ressemble. Nous avons plus d'une dizaine de cartes prépayées, 
                                    avec des programmes différents qui s'adaptent à tous les besoins et facilitent la vie.  Faites votre choix
                                </p>

                                

                                <!-- APP DEVICES -->	
                                <div class="app-devices clearfix " >	
                                
                                
                                     <!-- Text -->	
                                    <p data-animation="fadeInLeft" data-animation-delay="800">
                                        <!-- Button -->						
                                        <a href="https://cabine.apaym.com/achat-cartes" class="btn btn-lightorange" target="_blank">Commander carte</a>

                                        <!-- Button -->						
                                        <RouterLink to="nos-cartes" class="btn btn-lightgreen s_plus">En savoir plus</RouterLink>
                                    </p>

                                </div>


                            </div>	
                        </div>	<!-- END CONTENT TXT -->	


                        <!-- CONTENT IMAGE -->
                        <div class="col-md-6 " >	
                            <div class="content-5-img ind-15">
                                <img class="img-fluid im_cart_ev" src="@/assets/images/img-crte-ev.png" alt="content-image">
                            </div>
                        </div>


                    </div>	  <!-- End row -->
                </div>	   <!-- End container -->
            </div>		<!-- End Inner Background -->	
		</section>	
        <!-- END NOS CARTES VISA -->

        <!-- APAYM PRO-->
        <section id="pro" class="bg-scroll pro_m wide-60 content-section division pro_part">
            <div class="container">
                <div class="row d-flex align-items-center">


                    <!-- CONTENT IMAGE -->
                    <div class="col-md-5 " >
                        <div class="content-img reduc_mob">
                            <img class="img-fluid" src="@/assets/images/pic-apaym-pro.webp" alt="content-image" />
                        </div>
                    </div>


                    <!-- CONTENT TEXT -->
                    <div class="col-md-7">
                        <div class="content-txt ind-45">

                                    
                            <!-- Title -->	
                            <h2 class="h2-xs " >
                                APAYM Pro, encaisse comme <br> tu veux !
                            </h2>
                            
                            <!-- Text -->	
                            <p>APAYM Pro est une solution de paiement qui permet aux commerçants, petites et moyennes entreprises d’accepter tout mode de paiement digital.</p> 
                        
                            <!-- Title -->	
                            <h5 class="h5-md">
                                Plus de problème de cash
                            </h5>
                                            
                            <!-- Text -->	
                            <p >Rendez les paiements de vos clients plus simples en leur envoyant en une seconde un lien qui leur donne le choix de leur moyen de paiement. Le paiement s'effectue instantanément.</p>
                                           
                            <!-- Text -->	
                            <p>
                                <!-- Button -->						
                            <a href="https://apaym.com/pro/souscription" class="btn btn-lightorange">Créer un compte Pro</a>

                             <!-- Button -->						
                             <RouterLink to="/apaym-pro" class="btn btn-lightgreen s_plus">En savoir plus</RouterLink>
                            </p>


                        </div>
                    </div>	<!-- END CONTENT TEXT -->


                </div>	   <!-- End row -->		
            </div>	   <!-- End container -->		
        </section>	
        <!-- END APAYM PRO -->

        
        
        <!-- STATISTIC -->
		<div id="statistic" class="wide-60 stat pro_m statistic-section division">
				<div class="container">
					<div class="row d-flex align-items-center">


						<div class="col-md-6 m-bottom-40">
							<div class="row">


								<!-- STATISTIC BLOCK #1 -->
								<div class="col-sm-6 b-bottom b-right">							
									<div class="statistic-block text-center box-icon blue-icon " data-animation="fadeInUp" data-animation-delay="300">	
										<img src="@/assets/images/partners.webp" width="80">						
										<div><span class="stat_cl" >+</span><span class="statistic-number">1000</span></div>
										<p class="p-md">Marchands partenaires</p>
									</div>								
								</div>

								<!-- STATISTIC BLOCK #2 -->
								<div class="col-sm-6 b-bottom">									
									<div class="statistic-block text-center box-icon blue-icon " data-animation="fadeInUp" data-animation-delay="400">		
										<img src="@/assets/images/percents.webp" width="80">
                                        <div><span class="statistic-number">20 </span><span>% </span></div>
										<p class="p-md">Reduction chez nos partenaires</p>
									</div>							
								</div>

								<!-- STATISTIC BLOCK #3 -->
								<div class="col-sm-6 b-right sub_stat">							
									<div class="statistic-block text-center box-icon blue-icon " data-animation="fadeInUp" data-animation-delay="500">		
										<img src="@/assets/images/smile.webp" width="70">									
										<div><span class="stat_cl" >+</span><span class="statistic-number">40000</span></div>
										<p class="p-md">Utilisateurs heureux</p>	
									</div>						
								</div>

								<!-- STATISTIC BLOCK #4 -->
								<div class="col-sm-6 sub_stat">							
									<div class="statistic-block text-center box-icon blue-icon " data-animation="fadeInUp" data-animation-delay="600">		
										<img src="@/assets/images/icones-agence.webp" width="70">				
										<div><span class="stat_cl" ></span><span class="statistic-number">6</span></div>
										<p class="p-md ">Agences</p>
									</div>						
								</div>
                                

							</div>
						</div>	<!-- END STATISTIC BLOCKS -->


						<!-- STATISTIC IMAGE -->
						<div class="col-md-6 col-lg-5 offset-lg-1 " data-animation="fadeInLeft" data-animation-delay="400">	
							<div class="statistic-img text-center m-bottom-0">
								<img class="img-fluid" src="@/assets/images/pic-feedback.webp" alt="content-image" />								
							</div>
						</div>	<!-- END STATISTIC IMAGE -->


					</div>	 <!-- End row -->			
				</div>	 <!-- End container -->		
		</div>	
        <!-- END STATISTIC -->

		<!-- VIDEO -->
		<section id="video-3" class="bg-scroll bg-dark video-section division">
			<div class="container">


                <!-- SECTION TITLE -->	
                <div class="row">	
                    <div class="col-md-10 offset-md-1 white-color section-title">	

                        <!-- Title 	-->	
                        <h2 class="h2-lg">Comment ça marche ?</h2>	

                        <!-- Text -->
                        <p>APAYM réunit le meilleur du paiement mobile et les fonctionnalités clés pour la gestion de votre argent
                        </p>
                                    
                    </div> 	 <!-- End row --> 	
                </div>	 <!-- END SECTION TITLE -->	

                <div class="row">
                    <div class="video-inner-bg">
                        <div class="col-xl-10 offset-xl-1">		 				
                            <div class="video-content">
                                <div class="row d-flex align-items-center">


                                    <!-- VIDEO TEXT -->
                                    <div class="col-md-7">
                                        <div class="video-txt p-right-30">

                                        
                                            <!-- Title -->	
                                            <h4 class="h4-xl">APAYM - Comme tu veux</h4>

                                            <!-- Text -->	
                                            <p>La Super App APAYM vous permets de gérer vos finances en temps réel partout dans le monde, faire des transferts vers toutes les cartes Visa,<br>
                                                 compte bancaires et Mobile Money quelque soit votre banque.
                                            </p> 
                                            <!-- Text  -->	
                                            <p>Effectuer des Transferts Mobile Money (Orange, MTN et Moov) vers d’autres pays en Afrique.<br>

                                            Transférer de l’argent vers des services d’envoie d’argent Express (Express Union et WARI).
                                            </p>

                                            <!-- Button -->
                                            <RouterLink to="tutos" class="btn btn-lightorange">Voir nos tutos</RouterLink>


                                        </div>
                                    </div>	<!-- END VIDEO TEXT -->


                                    <!-- VIDEO PREVIEW -->
                                    <div class="col-md-5">
                                        <div class="video-preview text-center">

                                        
                                            <!-- Change the link HERE!!! -->
                                            <a class="video-popup" href="https://www.youtube.com/watch?v=cLv--GVAndU">
                                                    
                                                <!-- Play Icon -->
                                                <div class="video-block-wrapper"><div class="play-icon-green"></div></div>
                                                        
                                                <!-- Preview Image -->
                                                <img class="img-fluid v_tuto" src="@/assets/images/app-new.webp" alt="video-preview">

                                            </a>


                                        </div>
                                    </div>	<!-- END VIDEO PREVIEW -->

                            
                                </div>	<!-- End row -->
                            </div>	<!-- End video-content -->
                        </div>	 <!-- END CONTENT TEXT -->
                    </div>	  <!-- End Inner Background -->

                   
                </div>	   <!-- End row -->	


			</div>	   <!-- End container -->		
		</section>	
        <!-- END VIDEO -->

        <section id="download-4" class="bg-fixed contact-bck pro_m p-top-100 download-section division grey_bck_section">
            <div class="container">
                <div class="row">

                       <p></p>         
                    <!-- DOWNLOAD TEXT -->
                    <div class="col-lg-10 offset-lg-1">	
                        <div class="download-txt">
                            
                            <!-- Title -->
                            <h2 class="h2-xs">Qu'est ce que vous attendez ?</h2>

                            <!-- Text -->
                            <p class="p-lg">Ne perdez plus de temps à vous soucier de vos paiements en ligne. Téléchargez dès maintenant l'application APAYM et simplifiez votre vie en un instant.</p>

                            <!-- HERO STORE BADGES -->													
                            <div class="stores-badge">

                                 <!-- Google Play -->
                                 <a href="https://play.google.com/store/apps/details?id=weblogy.com.carteabidjan" class="store">
                                    <img class="appstore-original badge_sect" src="@/assets/images/play_store_badge.webp" alt="appstore-logo">
                                </a> 

                               <!-- AppStore -->
                                <a href="https://apps.apple.com/app/id1211381693" class="store">
                                    <img class="googleplay-original badge_sect" src="@/assets/images/app-store-bage.webp"  alt="googleplay-logo">
                                </a>                                                                            
                                
                                <!-- App Gallery -->
                                <a href="https://appgallery.huawei.com/app/C104470711" class="store">
                                    <img class="googleplay-original badge_sect" src="@/assets/images/app-gallery-badge.webp"  alt="googleplay-logo">
                                </a>

                            </div>


                        </div>
                    </div>	 <!-- END DOWNLOAD TEXT -->


                    <!-- DOWNLOAD IMAGE -->
                    <div class="col-md-12">	
                        <div class="download-img text-center">
                            <img class="img-fluid" src="@/assets/images/phones_app.webp" alt="download-image">
                        </div>
                    </div>

                    
                </div>	  <!-- End row -->
            </div>	   <!-- End container -->		
        </section>
       
        <footer_menu></footer_menu>    


    </div>

</template>

<script>
    import header_menu  from '../components/header_menu.vue';
    import footer_menu  from '../components/footer_menu.vue';
    

    


    export default{
    name:'home_view',
    components:{
    'header_menu' :header_menu,
    'footer_menu' :footer_menu,
    },

        

        
    methods: {

            showWarning() {
                
                this.$swal.fire({
                    title: '<strong>Information</strong>',
                    icon: 'info',
                    html:
                        'Le service est en cours d\'implémentation,' +
                        
                        '<br>il sera bientôt disponible !',
                    showCloseButton: false,
                    showCancelButton: false,
                    focusConfirm: false,
                    confirmButtonText:'OK',
                    confirmButtonColor:'#261b64',
                    iconColor:'#ff9e00'                 
                    
                }) 
                
            }

            
        },

       

    
    } 

</script>

<style scoped>

.navbar.bg-tra {
    //background-color: transparent;
    //background-color: #33267c !important;
    background-color: #33267c2e !important;
}

.statistic-section{
    padding-bottom: 0px !important;
}
h2.h2-lg { font-size: 2.8rem; }   /* 60px */
.img-choice{
    max-width: 100px;
    width: 100%;
}

.pro_part {
    background: url(@/assets/images/pic-pro-interne.png) no-repeat;
}
.stat{
    background: #fafafa;
}

.contact-bck {
    background-image: url(@/assets/images/tra-waves-contact.png)!important;
    background-position: bottom center;
}

.fbox-3 {
    width: 280px;
    height: 280px;
    position: relative;
    text-align: center;
    background-color: #fff;
    border: 1px solid #f1f1f2;
    
    border-radius: 50%;
    padding: 50px 30px;
    margin-bottom: 30px;
    transition: all 300ms ease-in-out;
    margin: auto;
    margin-bottom: 30px;
}

.s_plus{
    margin-left: 30px;
    background-color: #261b64;
    border-color: #261b64;
    color: #fff;
}
.bg-lightpurple {
    /*background-color: #261b64;*/
    background: linear-gradient(31deg,#7763f5,#261b64);
}
.bg-dark {
    background-color: #261b64!important;
}
.btn-lightorange {
    color: #fff;
    background-color: #ff9e00;
    border-color: #f3a72e;
}
.bg-green {
    background-color: #261b64;
}
.bottom-form-header {
    background-color: #ff9e00;
    border-color: #fe9d02;
    padding: 14px 20px;
    min-height: 45px;
    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
    cursor: pointer;
}

.im_cart_ev{
max-width: 630px;
margin-top: -130px;
}
.p-top-100 {
    padding-top: 140px;
}
.screen_app{
max-width: 300px;
width: 100%;
}

.blog-post-txt p {
    margin-bottom: 18px;
    text-align: center;
}
.blog-post h5 {
    margin-bottom: 15px;
    text-align: center;
}
.sp{
    padding-right: 30px;
    padding-left: 30px;
}
.btn-prenst{
    width: 310px;
    background: #261b64;
    border: none;
    text-decoration: none;
}
.btn-prenst:hover{
    width: 310px;
    background: #261b64;
    border: none;
    text-decoration: none;
    color: #ffc76c;
}

.blog-post-txt{
    text-align: center;
}
.blog-post-txt p[data-v-6b0f3edb] {
    margin-bottom: 30px;
    text-align: center;
}

.subtitle{
    color: #7c7b7b;   
}
.blue-icon span {
    background: -webkit-gradient(linear, left top, left bottom, from(#000000), to(#000000));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 39px;
}
.sub_stat{
    padding-top:30px ;
}
.agce{
    font-size: 39px;    
}
.b_ios{
   
    height: 100px;
    background: url(../../public/assets/images/store_badges/appstore-tra-white.png) no-repeat;
    background-size: 150px 50px;
}
.first_im{
    max-width: 560px;
}

.im_apear{
    max-width: 343px;
    margin-top: 30px;
    width: 100%;
    display: block;
    margin: auto;
    display: none;
}
.badge_sect{
    max-width: 130px;
}

@media screen and (max-width: 767px) {

    .reduc_mob{
        margin-bottom: 0px !important;
    }

    .p-top-100[data-v-6b0f3edb] {
    padding-top: 40px;
}
    .im_apear{
    display: block !important;
    max-width: 343px;
    margin-top: 30px;
    width: 100%;
    display: block;
    margin: auto;
    }

    .im_cart_ev{
        display: none;

    }
    .store img.appstore-white {
    width: 105px !important;
    height: 38px !important;
    }
    .first_im {
    max-width: 330px !important;
}

.fbox-3 {
    width: 155px !important;
    height: 155px !important;
    position: relative;
    text-align: center;
    background-color: #fff;
    border: 1px solid #ffffff !important;
    border-radius: 50%;
    padding: 10px 30px;
    transition: all 300ms ease-in-out;
    margin: auto;
    margin-bottom: 30px;
}

    h5.h5-md {
        font-size: 0.9rem;
    }

    .bounce{
    position: relative;
    width: 50% !important;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
        
    }
    .badge_sect{
    max-width: 108px !important;
    }

    .play-icon-green {
    width: 100px;
    height: 100px;
    background: url(../../public/assets/images/play_Plan.webp);
    margin-top: -50px;
    margin-left: -50px;
}
.v_tuto{
    max-width: 70% !important;
    height: auto;
}

.pro_m {
    padding-top: 40px !important;
   
}

}
/*fin media query 768px */
.down{
    width: 400px;
    height: 69px;
    background: #261c65;
    border-radius: 10px;
    font-weight: 500;
    font-size: 1.1rem;
    text-align: center;
    line-height: 3.7;
}
.p-bottom-80 {
     padding-bottom: 0; 
}

</style>